import { CloudCommand } from "../types.js";

export const getGroups: CloudCommand = {
    action: "GROUPS/GET_GROUPS",
    commandName: "groups.getGroups",
    buildPayload: ({ start, memberId }) => ({ start, memberId }),
    transformResponse: (data) => data,
};
